export type Falsey = false | null | undefined;
export type ClassValue = string | Falsey | Array<ClassValue>;

function flatten(val: ClassValue): string[] {
  if (Array.isArray(val)) {
    return val.flatMap(flatten);
  }
  return val ? [val] : [];
}

export function classNames(...classes: ClassValue[]): string {
  return classes.flatMap(flatten).filter(Boolean).join(' ');
}
